




























import { Vue, Prop, Component } from 'vue-property-decorator'

@Component({
  components: {
    RichText: () => import('@ivy/fts/comps/RichText.vue')
  }
})
export default class LessonDesc extends Vue {
  @Prop() detail: any
  @Prop() hasBought: any

}
